import script from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"

import "./DepthContainer.vue?vue&type=style&index=0&id=40b8af2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b8af2c"]])

export default __exports__